import { IndustryTemplate } from '@/components';
import { pestControlContent } from '@/data/industries/pestcontrol';

export function PestControlPage() {
  return <IndustryTemplate content={pestControlContent} />;
}
